import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
// import TemplateSelect from "../../../../Checklists/components/checklistTemplate/templateSelect/templateSelect.vue";
import TemplateSelect from '../ChecklistTemplate/templateSelect/templateSelect.vue'
// import TTable from "../../../../../components/T/TTable.vue";

export default {
  components: {
    TemplateSelect,
    // TTable,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userType = this.institution.userType
    this.mainType = this.userLogged.mainType
    this.institutionId = this.institution.id

    this.values.push(this.institutionId)
    this.filter.institutionIds = [this.institutionId]

    await Promise.all([
      this.getInstitutions(),
      this.getWorkshops(),
      this.getDepartments(),
      this.getSolutions(),
      this.getStandardEquipments(),
      this.getUsers(),
      this.getUsersByType(),
      this.getManufacturers(),
    ])
    try {
      const columns = JSON.parse(this.userLogged.bigDataOsColumns)
      this.headers = columns ? columns : this.headers
    } catch (_) {}

    await this.loadPreset()
  },

  data: () => ({
    presetLoading: false,
    hasSavedPreset: false,
    mainType: false,
    solutionLoading: [],
    informeDialog: false,
    standardEquipments: [],
    typeOSSearch: '',
    criticalitySearch: '',
    mainType: null,
    UnitSeach: '',
    manufacturers: [],
    statusSearch: '',
    search: '',
    subSectorSearch: '',
    equipSearch: '',
    situations: [
      { text: 'Aluguel', value: 0 },
      { text: 'Comodato', value: 1 },
      { text: 'De médico/Equipe', value: 2 },
      { text: 'Empréstimo', value: 3 },
      { text: 'Próprio', value: 4 },
      { text: 'Terceiros', value: 5 },
      { text: 'Convênio', value: 6 },
      { text: 'Doação', value: 7 },
    ],
    localDepartments: [],
    solutions: [],
    statusSearch: '',
    institutionSearch: '',
    responsibleName: '',
    responsibleUsers: [],
    workshopTypes: [
      { text: 'Engenharia Clínica', value: 0 },
      { text: 'Carpintaria', value: 1 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    workshopType: null,
    errorMessage: '',
    expanded: [],
    values: [],
    totalItensOnPage: 0,
    menuStartDate: false,
    menuEndDate: false,
    menuInitialCloseDate: false,
    menuFinalCloseDate: false,
    visible: false,
    activeOstemplateDialog: false,
    inactiveOsTemplateDialog: false,
    templateSelectDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    printDialog: false,
    buttonDeleteVisible: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    userLoading: false,
    standardEquipmentLoading: false,
    printChecklistLoading: false,
    printLoading: false,
    error: false,
    newChecklist: false,
    departmentInactive: false,
    startDate: null,
    endDate: null,
    requestMinDate: null,
    initialCloseDate: null,
    finalCloseDate: null,
    closeMinDate: null,
    search: null,
    sortBy: [],
    sortDesc: [],
    serviceOrders: [],
    serviceOrdersSelected: [],
    currentServiceOrder: {},
    serviceOrderCosts: [],
    serviceOrderServices: [],
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    departmentId: null,
    departments: [],
    userId: null,
    users: [],
    userLogged: {},
    userType: null,
    standardEquipment: null,
    standardEquimpents: [],
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Deslocamento',
      'Equipamento não encontrado',
      'Aguardando Solicitação/Ordem de Compra',
    ],
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviço Administrativo',
      'Empréstimo',
      null,
      'Obras',
      'Serviço Operacional',
    ],
    causeDefects: [
      'Não aplicável',
      'Falha intríseca',
      'Falha infraestrutura',
      'Erro operacional',
      'Dano acidental',
      'Abuso na utilização',
    ],
    serviceOrderStatus: [
      { text: 'Abertas', value: 0 },
      { text: 'Fechadas', value: 1 },
      { text: 'Manutenção terceirizada in loco', value: 2 },
      { text: 'Manutenção terceirizada externa', value: 3 },
      { text: 'Manutenção interna', value: 4 },
      { text: 'Aguardando peça', value: 5 },
      { text: 'Aguardando orçamento', value: 6 },
      { text: 'Aguardando avaliação externa', value: 7 },
      { text: 'Aguardando aprovação de orçamento', value: 8 },
      { text: 'Aguardando liberação do setor', value: 9 },
      { text: 'Deslocamento', value: 10 },
      { text: 'Equipamento não encontrado', value: 11 },
      { text: 'Aguardando Solicitação/Ordem de Compra', value: 12 },
    ],
    responsibilities: ['Interna', 'Externa'],
    categories: ['Equipamento', 'Setor'],
    criticalities: ['Baixa', 'Média', 'Alta'],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    filter: {
      isArchived: false,
      page: 1,
      pageSize: 10,
      institutionId: null,
      unidadeId: null,
      institutionIds: [],
      standardEquipment: null,
      equipmentName: null,
      equipmentSerialNumber: null,
      equipmentIdentification: null,
      equipmentDepartmentId: null,
      criticalities: [],
      equipmentPropertyCode: null,
      serviceOrderType: [],
      userResponsibleStep: null,
      serviceOrderNumber: null,
      requestStartDate: null,
      requestEndDate: null,
      initialCloseDate: null,
      finalCloseDate: null,
      causeDefect: null,
      status: null,
      genericSearch: null,
      responsibility: null,
      category: null,
      ordination: null,
    },
    serviceOrderName: null,
    standardEquipmentName: null,
    serviceOrderNumber: null,
    serviceOrderType: null,
    serviceOrderLastStep: null,
    serviceOrderRequeter: null,
    serviceOrderRequestDate: null,
    serviceOrderAttendDate: null,
    serviceOrderCloseDate: null,
    equipmentName: null,
    equipmentSerialNumber: null,
    equipmentIdentification: null,
    equipmentDepartmentId: null,
    criticalitiesSelected: [],
    equipmentPropertyCode: null,
    serviceOrderTypeSelected: [],
    userResponsibleStep: null,
    requestStartDate: null,
    requestEndDate: null,
    serviceOrderinitialCloseDate: null,
    serviceOrderfinalCloseDate: null,
    causeDefect: null,
    status: null,
    genericSearch: null,
    responsibility: null,
    category: null,
    headMenu: false,
    menuLoading: false,
    headers: [
      {
        text: 'Nº O.S.',
        align: 'center',
        value: 'number',
        active: true,
        width: 20,
      },
      {
        text: 'Estado Etapa',
        align: 'center',
        value: 'services[0].statusStepServiceOrder',
        active: false,
        width: 20,
      },
      {
        text: 'Código Patrimônio',
        align: 'center',
        value: 'equipment.propertyCode',
        active: false,
        width: 20,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'equipment.manufacturer',
        active: false,
        width: 20,
      },
      {
        text: 'Centro de custo',
        align: 'center',
        value: 'costCenter.name',
        active: false,
        width: 20,
      },
      {
        text: 'Número de série',
        align: 'center',
        value: 'equipment.serialNumber',
        active: false,
        width: 20,
      },
      {
        text: 'Nome O.S.',
        align: 'center',
        value: 'name',
        active: true,
        width: 100,
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'unidade.name',
        active: false,
        width: 20,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department.name',
        active: false,
        width: 20,
      },
      {
        text: 'E. Padrão',
        align: 'center',
        value: 'equipment.standardEquipment.name',
        active: true,
        width: 100,
      },
      {
        text: 'Tipo O.S.',
        align: 'center',
        value: 'serviceOrderType',
        active: true,
        width: 60,
      },
      {
        text: 'Responsável',
        align: 'center',
        value: 'responsibleName',
        active: false,
        width: 20,
      },
      {
        text: 'Dt.Solic.',
        align: 'center',
        value: 'dateTimeRequest',
        active: true,
        width: 80,
      },
      {
        text: 'Dt.Fecham.',
        align: 'center',
        value: 'closeServiceOrderDateTime',
        active: true,
        width: 80,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'equipment.identification',
        active: true,
        width: 130,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        active: true,
        width: 250,
      },
    ],
    headersMobile: [
      {
        text: 'Nome O.S.',
        align: 'center',
        active: true,
        value: 'name',
      },
      {
        text: 'Ações',
        active: true,
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  computed: {
    icon() {
      if (this.likesAllInstitution) return 'mdi-close-box'
      if (this.likesSomeInstitution) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    likesSomeInstitution() {
      return this.values.length > 0 && !this.likesAllInstitution
    },
    likesAllInstitution() {
      return this.values.length === this.institutions.length
    },
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) =>
          this.filter.equipmentDepartmentIds &&
          this.filter.equipmentDepartmentIds.includes(x.id)
      )

      return departments.map((x) => x.subDepartments).flat(1)
    },

    filteredServiceOrderTypes() {
      return this.serviceOrderTypes.filter((type) => {
        if (type === null) return false
        // Filtrar "Obras" se a instituição não tiver manutenção predial
        if (type === 'Obras' && !this.institution.departmentTypes.includes(1)) {
          return false
        }
        return true
      })
    },
  },

  methods: {
    getPresetData() {
      return {
        values: this.values,
        unidadeId: this.unidadeId,
        serviceOrderTypeSelected: this.serviceOrderTypeSelected,
        equipmentName: this.equipmentName,
        equipmentSerialNumber: this.equipmentSerialNumber,
        equipmentIdentification: this.equipmentIdentification,
        equipmentPropertyCode: this.equipmentPropertyCode,
        serviceOrderNumber: this.serviceOrderNumber,
        requestStartDate: this.requestStartDate,
        requestEndDate: this.requestEndDate,
        startDate: this.startDate,
        endDate: this.endDate,
        serviceOrderinitialCloseDate: this.serviceOrderinitialCloseDate,
        serviceOrderfinalCloseDate: this.serviceOrderfinalCloseDate,
        initialCloseDate: this.initialCloseDate,
        finalCloseDate: this.finalCloseDate,
        causeDefect: this.causeDefect,
        genericSearch: this.genericSearch,
        responsibility: this.responsibility,
        category: this.category,
        responsibleName: this.responsibleName,
        filterStatus: this.filter.status,
        filterIsArchived: this.filter.isArchived,
        filterInternalTeam: this.filter.internalTeam,
        filterIsProactive: this.filter.isProactive,
        filterIsValidated: this.filter.isValidated,
        filterWorkshopType: this.filter.workshopType,
        filterSituation: this.filter.situation,
        filterEquipmentManufacturer: this.filter.equipmentManufacturer,
        filterDefectSolutionId: this.filter.defectSolutionId,
        filterStandardEquipmentIds: this.filter.standardEquipmentIds,
        filterEquipmentDepartmentIds: this.filter.equipmentDepartmentIds,
        filterSubDepartmentIds: this.filter.subDepartmentIds,
        criticalities: this.criticalitiesSelected,
      }
    },

    applyPreset(data) {
      if (data.values !== undefined) this.values = data.values
      if (data.unidadeId !== undefined) this.unidadeId = data.unidadeId
      if (data.serviceOrderTypeSelected !== undefined) this.serviceOrderTypeSelected = data.serviceOrderTypeSelected
      if (data.equipmentName !== undefined) this.equipmentName = data.equipmentName
      if (data.equipmentSerialNumber !== undefined) this.equipmentSerialNumber = data.equipmentSerialNumber
      if (data.equipmentIdentification !== undefined) this.equipmentIdentification = data.equipmentIdentification
      if (data.equipmentPropertyCode !== undefined) this.equipmentPropertyCode = data.equipmentPropertyCode
      if (data.serviceOrderNumber !== undefined) this.serviceOrderNumber = data.serviceOrderNumber
      if (data.requestStartDate !== undefined) this.requestStartDate = data.requestStartDate
      if (data.requestEndDate !== undefined) this.requestEndDate = data.requestEndDate
      if (data.startDate !== undefined) this.startDate = data.startDate
      if (data.endDate !== undefined) this.endDate = data.endDate
      if (data.serviceOrderinitialCloseDate !== undefined) this.serviceOrderinitialCloseDate = data.serviceOrderinitialCloseDate
      if (data.serviceOrderfinalCloseDate !== undefined) this.serviceOrderfinalCloseDate = data.serviceOrderfinalCloseDate
      if (data.initialCloseDate !== undefined) this.initialCloseDate = data.initialCloseDate
      if (data.finalCloseDate !== undefined) this.finalCloseDate = data.finalCloseDate
      if (data.causeDefect !== undefined) this.causeDefect = data.causeDefect
      if (data.genericSearch !== undefined) this.genericSearch = data.genericSearch
      if (data.responsibility !== undefined) this.responsibility = data.responsibility
      if (data.category !== undefined) this.category = data.category
      if (data.responsibleName !== undefined) this.responsibleName = data.responsibleName
      if (data.filterStatus !== undefined) this.filter.status = data.filterStatus
      if (data.filterIsArchived !== undefined) this.filter.isArchived = data.filterIsArchived
      if (data.filterInternalTeam !== undefined) this.filter.internalTeam = data.filterInternalTeam
      if (data.filterIsProactive !== undefined) this.filter.isProactive = data.filterIsProactive
      if (data.filterIsValidated !== undefined) this.filter.isValidated = data.filterIsValidated
      if (data.filterWorkshopType !== undefined) this.filter.workshopType = data.filterWorkshopType
      if (data.filterSituation !== undefined) this.filter.situation = data.filterSituation
      if (data.filterEquipmentManufacturer !== undefined) this.filter.equipmentManufacturer = data.filterEquipmentManufacturer
      if (data.filterDefectSolutionId !== undefined) this.filter.defectSolutionId = data.filterDefectSolutionId
      if (data.filterStandardEquipmentIds !== undefined) this.filter.standardEquipmentIds = data.filterStandardEquipmentIds
      if (data.filterEquipmentDepartmentIds !== undefined) this.filter.equipmentDepartmentIds = data.filterEquipmentDepartmentIds
      if (data.filterSubDepartmentIds !== undefined) this.filter.subDepartmentIds = data.filterSubDepartmentIds
      if (data.criticalities !== undefined) this.criticalitiesSelected = data.criticalities
      else if (typeof data.criticality === 'string' && data.criticality) this.criticalitiesSelected = [data.criticality]
      else this.applyLegacyCriticality(data)
    },

    // Presets salvos antes da troca do filtro guardam a faixa numérica
    // (equipmentCriticalityMin/Max) no lugar do rótulo Baixa/Média/Alta. Só dá para
    // converter para as bandas tocadas pela faixa: uma faixa que cruza bandas vira
    // todas elas, nunca restringindo mais do que o usuário salvou.
    applyLegacyCriticality(data) {
      const min = this.criticalityScoreOf(data.equipmentCriticalityMin)
      const max = this.criticalityScoreOf(data.equipmentCriticalityMax)
      if (min === null && max === null) return

      // Faixa aberta: sem piso vale desde 0, sem teto vale até o topo (Alta).
      const minLabel = this.criticalityLabelOf(min === null ? 0 : min)
      const maxLabel = this.criticalityLabelOf(max === null ? 19 : max)

      const labels = ['Baixa', 'Média', 'Alta']
      const from = labels.indexOf(minLabel)
      const to = labels.indexOf(maxLabel)
      if (from > to) return

      this.criticalitiesSelected = labels.slice(from, to + 1)
    },

    criticalityScoreOf(value) {
      if (value === null || value === undefined || value === '') return null
      const score = Number(value)
      return Number.isNaN(score) ? null : score
    },

    criticalityLabelOf(score) {
      if (score >= 19) return 'Alta'
      if (score >= 12) return 'Média'
      return 'Baixa'
    },

    async loadPreset() {
      if (!this.userLogged.id) return
      try {
        const response = await this.apiService.get(
          `bigDataFilterPreset/${this.userLogged.id}/1`,
          null,
          false,
          false
        )
        if (response && response.content) {
          this.applyPreset(JSON.parse(response.content.filterJson))
          this.hasSavedPreset = true
          this.filterTable()
        }
      } catch (_) {}
    },

    async savePreset() {
      this.presetLoading = true
      try {
        await this.apiService.post('bigDataFilterPreset', {
          userId: this.userLogged.id,
          tab: 1,
          filterJson: JSON.stringify(this.getPresetData()),
        })
        this.hasSavedPreset = true
        this.$toast.success('Filtro salvo com sucesso!')
      } catch (_) {
        this.$toast.error('Erro ao salvar filtro')
      }
      this.presetLoading = false
    },

    async removePreset() {
      this.presetLoading = true
      try {
        await this.apiService.delete(
          `bigDataFilterPreset/${this.userLogged.id}/1`,
          null,
          false,
          false
        )
        this.hasSavedPreset = false
        this.$toast.success('Filtro salvo removido!')
      } catch (_) {
        this.$toast.error('Erro ao remover filtro')
      }
      this.presetLoading = false
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllInstitution) {
          this.values = []
        } else {
          this.values = this.institutions.map((x) => x.id).slice()
        }
      })
    },

    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },
    removeDepartment(item) {
      this.filter.equipmentDepartmentIds.splice(item, 1)
      this.filter.equipmentDepartmentIds = [
        ...this.filter.equipmentDepartmentIds,
      ]
    },
    removeSubDepartment(item) {
      this.filter.subDepartmentIds.splice(item, 1)
      this.filter.subDepartmentIds = [...this.filter.subDepartmentIds]
    },
    removeStandardEquipment(item) {
      this.filter.standardEquipmentIds.splice(item, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },
    removeStatus(item) {
      this.filter.status.splice(item, 1)
      this.filter.status = [...this.filter.status]
    },

    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    async getWorkshops() {
      await this.apiService
        .get('workshop/' + this.institution.id, true, false)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getUsersByType() {
      await this.apiService
        .post(`user/byType`, {
          ids: this.values,
        })
        .then((response) => {
          this.responsibleUsers = response.content
        })
    },

    addServiceOrder() {
      sessionStorage.clear()
      this.$router.push({ name: 'newServiceOrder' })
    },

    editServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      const route = this.$router.resolve({
        path: `/bigData-editServiceOrder/${this.currentServiceOrder.id}/${this.currentServiceOrder.institutionId}`,
      })
      window.open(route.href, '_blank')
    },

    uploadDocument(serviceOrder) {
      sessionStorage.clear()
      this.currentServiceOrder = serviceOrder
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      const url = this.$router.resolve({ path: '/bigData-uploadDocument' }).href
      window.open(url, '_blank')
    },

    deleteServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManySeviceOrders() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    openAbout(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    handleSortUpdate({ sortBy, sortDesc }) {
      if (sortBy[0] == 'number' && !sortDesc[0]) {
        this.filter.ordination = 0
      } else if (sortBy[0] == 'number' && sortDesc[0]) {
        this.filter.ordination = 1
      }
      // this.updateTable()
    },

    setChecklistButtonColor(serviceOrder) {
      return serviceOrder.checklists && serviceOrder.checklists.length > 0
        ? '#BBCF20'
        : '#426483'
    },

    openChecklist(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      if (this.userType < 4) {
        if (
          serviceOrder.status == 0 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.activeOstemplateDialog = true
        } else if (
          serviceOrder.status == 1 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.inactiveOsTemplateDialog = true
        } else if (
          serviceOrder.department.status == 1 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.inactiveOsTemplateDialog = true
        } else {
          this.openTemplateSelect()
        }
      } else if (
        serviceOrder.checklistTemplateId != null &&
        serviceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else {
        return
      }
    },

    openTemplateSelect() {
      this.newChecklist = true
      this.activeOstemplateDialog = false
      this.templateSelectDialog = true
      this.dialogKey = !this.dialogKey
    },
    removeInstitution(item) {
      this.values.splice(this.values.indexOf(item), 1)
      this.values = [...this.values]
    },

    async viewChecklist() {
      await this.apiService
        .get(
          `serviceOrder/getServiceOrder/${this.currentServiceOrder.institutionId}/${this.currentServiceOrder.id}`
        )
        .then((response) => {
          const checklist = response.content.checklists[0]
          const checklistServiceOrder = {
            ServiceOrderId: checklist.serviceOrderId,
            ChecklistId: checklist.id,
            isValidatorSigned: checklist.isValidatorSigned,
            EquipmentId: checklist.equipmentId,
          }
          sessionStorage.setItem(
            'checklist',
            JSON.stringify(checklistServiceOrder)
          )
          const route = this.$router.resolve({
            path: '/bigData-formChecklist',
          })
          window.open(route.href, '_blank')
          this.activeOstemplateDialog = false
          this.inactiveOsTemplateDialog = false
        })
    },

    closeDialog() {
      this.dialog = false
      this.aboutDialog = false
      this.templateSelectDialog = false

      this.updateTable()
    },

    openCalibration(serviceOrder) {
      sessionStorage.clear()
      this.currentServiceOrder = serviceOrder
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      this.$router.push({ path: '/bigData-formCalibration' })
    },

    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },

    removeCriticality(item) {
      this.criticalitiesSelected = this.criticalitiesSelected.filter(
        (c) => c !== item
      )
    },

    isInactive(value) {
      if (value.department) {
        return value.department.status == 1 ? 'departmentInactive' : ''
      }
      return value.equipment.department.status == 1 ? 'departmentInactive' : ''
    },

    filterTable() {
      if (!this.$refs['inst-form'].validate()) return

      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.unidadeId = this.unidadeId
      this.filter.standardEquipmentId = this.standardEquipmentId
      this.filter.equipmentName = this.equipmentName
      this.filter.equipmentSerialNumber = this.equipmentSerialNumber
      this.filter.equipmentIdentification = this.equipmentIdentification
      this.filter.equipmentDepartmentId = this.departmentId
      this.filter.criticalities = this.criticalitiesSelected
        .map((c) => this.criticalities.indexOf(c))
        .filter((i) => i !== -1)
      this.filter.equipmentPropertyCode = this.equipmentPropertyCode
      this.filter.userResponsibleStep = this.userId
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.requestStartDate = this.requestStartDate
      this.filter.requestEndDate = this.requestEndDate
      this.filter.responsibleName = this.responsibleName
      this.filter.initialCloseDate = this.serviceOrderinitialCloseDate
      this.filter.finalCloseDate = this.serviceOrderfinalCloseDate
      this.filter.causeDefect =
        this.causeDefects.indexOf(this.causeDefect) == -1
          ? null
          : this.causeDefects.indexOf(this.causeDefect)

      this.filter.genericSearch = this.genericSearch
      this.filter.responsibility =
        this.responsibilities.indexOf(this.responsibility) == -1
          ? null
          : this.responsibilities.indexOf(this.responsibility)
      this.filter.category =
        this.categories.indexOf(this.category) == -1
          ? null
          : this.categories.indexOf(this.category)

      if (this.serviceOrderTypeSelected.length > 0) {
        this.filter.serviceOrderType = []
        this.serviceOrderTypeSelected.map((type) => {
          this.filter.serviceOrderType.push(
            this.serviceOrderTypes.indexOf(type)
          )
        })
      } else {
        this.filter.serviceOrderType = []
      }
      if (this.filter.responsibility == 1) this.filter.internalTeam = null
      this.updateTable()
    },

    getLastStep(array) {
      const lastStep = array[array.length - 1]

      if (lastStep) {
        switch (lastStep.statusStepServiceOrder) {
          case 0:
            return 'Manutenção terceirizada in loco'
          case 1:
            return 'Manutenção terceirizada externa'
          case 2:
            return 'Manutenção interna'
          case 3:
            return 'Aguardando peça'
          case 4:
            return 'Aguardando orçamento'
          case 5:
            return 'Aguardando avaliação externa'
          case 6:
            return 'Aguardando aprovação de orçamento'
          case 7:
            return 'Aguardando liberação do setor'
          default:
            return 'Sem registro'
        }
      }
      return 'Sem registro'
    },

    async generateChecklistPDF() {
      const checklist = this.currentServiceOrder.checklists[0]
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
      this.inactiveOsTemplateDialog = false
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionIds = this.values

      await this.apiService
        .post('bigdata/serviceOrder', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.serviceOrders = response.content.serviceOrders
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.serviceOrders.length
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    generateExcel() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.unidadeId = this.unidadeId
      this.filter.standardEquipmentId = this.standardEquipmentId
      this.filter.equipmentName = this.equipmentName
      this.filter.equipmentSerialNumber = this.equipmentSerialNumber
      this.filter.equipmentIdentification = this.equipmentIdentification
      this.filter.equipmentDepartmentId = this.departmentId
      this.filter.criticalities = this.criticalitiesSelected
        .map((c) => this.criticalities.indexOf(c))
        .filter((i) => i !== -1)
      this.filter.equipmentPropertyCode = this.equipmentPropertyCode
      this.filter.userResponsibleStep = this.userId
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.requestStartDate = this.requestStartDate
      this.filter.requestEndDate = this.requestEndDate
      this.filter.responsibleName = this.responsibleName
      this.filter.initialCloseDate = this.serviceOrderinitialCloseDate
      this.filter.finalCloseDate = this.serviceOrderfinalCloseDate
      this.filter.causeDefect =
        this.causeDefects.indexOf(this.causeDefect) == -1
          ? null
          : this.causeDefects.indexOf(this.causeDefect)

      this.filter.genericSearch = this.genericSearch
      this.filter.responsibility =
        this.responsibilities.indexOf(this.responsibility) == -1
          ? null
          : this.responsibilities.indexOf(this.responsibility)
      this.filter.category =
        this.categories.indexOf(this.category) == -1
          ? null
          : this.categories.indexOf(this.category)

      if (this.serviceOrderTypeSelected.length > 0) {
        this.filter.serviceOrderType = []
        this.serviceOrderTypeSelected.map((type) => {
          this.filter.serviceOrderType.push(
            this.serviceOrderTypes.indexOf(type)
          )
        })
      } else {
        this.filter.serviceOrderType = []
      }
      if (this.filter.responsibility == 1) this.filter.internalTeam = null
      this.filter.pageSize = null
      this.filter.institutionIds = this.values

      let now = new Date()
      var filename = `Ordens_Serviço_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      this.apiService
        .post('bigdata/serviceOrder/excel', this.filter)
        .then((response) => {
          if (response.length > 2) {
            response = `data:application/octet-stream;base64,${response}`
            const link = document.createElement('a')
            link.href = response
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          } else {
            this.informeDialog = true
          }
        })
    },

    async remove() {
      this.loading = true
      const serviceOrderId = this.currentServiceOrder.id

      await this.apiService
        .delete(`serviceOrder/delete/${serviceOrderId}`)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('serviceOrder/deleteMany', this.serviceOrdersSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.serviceOrdersSelected = []
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.values)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
          this.departmentLoading = false
        })
    },

    async getSolutions() {
      this.solutionLoading = true

      await this.apiService
        .get(`defectSolution/institution/${this.institutionId}`)
        .then((response) => {
          this.solutions = response.content
          this.solutionLoading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      await this.apiService
        .post(`bigdata/standardEquipment`, this.values)
        .then((response) => {
          this.standardEquimpents = response.content
          this.standardEquipmentLoading = false
        })
        .catch(() => {
          this.standardEquipmentLoading = false
        })
    },

    getStandardEquipmentName(value) {
      const equipment = this.standardEquimpents.find(
        (equipmentInstitution) =>
          equipmentInstitution.standardEquipmentId == value
      )

      if (equipment) {
        return equipment.standardEquipment.name
      }
      return 'Sem registro'
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async generatePDF(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      const route = this.$router.resolve({
        path: `printServiceOrder/${this.institutionId}/${this.currentServiceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    async getTemplateItems(serviceOrder) {
      const checklist = {
        ChecklistTemplate: serviceOrder.checklistTemplate,
        ServiceOrderId: serviceOrder.id,
      }
      sessionStorage.setItem('checklist', JSON.stringify(checklist))
      this.$router.push('/bigData-formChecklist')
    },
    updateHeaders() {
      this.menuLoading = true
      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/big-data-os', { columns: json })
        .then(() => {
          this.userLogged.bigDataOsColumns = json

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success('Configuração salva no seu usuário!')

          this.headMenu = false
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    saveRequestDate(date) {
      this.startDate = this.formatInputDate(this.requestStartDate)
      this.$refs.menuStartDate.save(date)
      this.requestMinDate = new Date(this.requestStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.requestEndDate)
      this.$refs.menuEndDate.save(date)
    },

    saveCloseDate(date) {
      this.initialCloseDate = this.formatInputDate(
        this.serviceOrderinitialCloseDate
      )
      this.$refs.menuInitialCloseDate.save(date)
      this.closeMinDate = new Date(this.serviceOrderinitialCloseDate)
        .toISOString()
        .substr(0, 10)
      this.finalCloseDate = this.formatInputDate(
        this.serviceOrderfinalCloseDate
      )
      this.$refs.menuFinalCloseDate.save(date)
    },

    reset() {
      this.filter.internalTeam = null
      this.page = 1
      this.serviceOrderName = null
      this.responsibleName = ''
      this.standardEquipmentName = null
      this.serviceOrderNumber = null
      this.serviceOrderType = null
      this.serviceOrderLastStep = null
      this.serviceOrderRequeter = null
      this.serviceOrderRequestDate = null
      this.serviceOrderAttendDate = null
      this.serviceOrderCloseDate = null
      this.equipmentName = null
      this.equipmentSerialNumber = null
      this.equipmentIdentification = null
      this.equipmentDepartmentId = null
      this.criticalitiesSelected = []
      this.equipmentPropertyCode = null
      this.serviceOrderTypeSelected = []
      this.userResponsibleStep = null
      this.requestStartDate = null
      this.startDate = null
      this.requestEndDate = null
      this.endDate = null
      this.serviceOrderinitialCloseDate = null
      this.initialCloseDate = null
      this.finalCloseDate = null
      this.serviceOrderfinalCloseDate = null
      this.causeDefect = null
      this.status = null
      this.genericSearch = null
      this.unidadeId =
        this.userType < 3 || this.userType == 8
          ? null
          : this.userLogged.unidadeId
      this.departmentId = null
      this.userId = null
      this.standardEquipmentId = null
      this.responsibility = null
      this.category = null
      this.serviceOrdersSelected = []
      this.values = []
      this.filter = {
        ...this.filter,
        institutionIds: [],
        isArchived: false,
        page: 1,
        pageSize: this.pageSize,
        institutionId: null,
        unidadeId: null,
        standardEquipmentIds: null,
        equipmentName: null,
        equipmentSerialNumber: null,
        equipmentIdentification: null,
        equipmentDepartmentId: null,
        criticalities: [],
        equipmentPropertyCode: null,
        serviceOrderType: [],
        responsibleName: '',
        userResponsibleStep: null,
        serviceOrderNumber: null,
        requestStartDate: null,
        requestEndDate: null,
        initialCloseDate: null,
        finalCloseDate: null,
        causeDefect: null,
        status: null,
        genericSearch: null,
        responsibility: null,
        category: null,
      }
      this.updateTable()
    },
  },

  watch: {
    unidadeId() {
      if (this.unidadeId) {
        this.localDepartments = this.departments.filter(
          (x) => x.unidadeId == this.unidadeId
        )
      } else {
        this.localDepartments = this.departments.filter((x) =>
          this.unidades.map((x) => x.id).includes(x.unidadeId)
        )
      }
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    serviceOrdersSelected() {
      this.buttonDeleteVisible = this.serviceOrdersSelected.length > 0
    },

    serviceOrderTypeSelected() {
      this.search = ''
    },
    values(nv, ov) {
      this.getUnidades()
      this.getDepartments()
      this.getStandardEquipments()
      this.getUsersByType()
    },

    'filter.status': {
      deep: true,
      handler() {
        this.statusSearch = ''
      },
    },
  },
}
